export const LECTURE_VIDEO_TYPES = {
    UTUBE: { text: "YOUTUBE", value: "UTUBE" },
    VIMEO: { text: "VIMEO", value: "VIMEO" },
};
